
export class Trigger {
  value: number = 0;
  threshold: number = -1;

  isTriggered() {
    return this.value > this.threshold;
  }
}
